interface Timespan {
  unit: 'month' | 'day' | 'hour' | 'minute' | 'second'
  amount?: number
}

const units = ['second', 'minute', 'hour', 'day', 'month']

const unitMs = {
  second: 1000,
  minute: 1000 * 60,
  hour: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24,
  month: 1000 * 60 * 60 * 24 * 30,
}

function floorBy(value: number, amount: number) {
  return Math.round(value / amount) * amount
}

export function floorDate(date: Date, { unit, amount = 1 }: Timespan) {
  const unitIndex = units.indexOf(unit)

  const roundedDate = new Date(date)

  if (unitIndex === 0) {
    roundedDate.setSeconds(floorBy(date.getSeconds(), amount), 0)
  }

  if (unitIndex === 1) {
    roundedDate.setMinutes(floorBy(date.getMinutes(), amount), 0, 0)
  }

  if (unitIndex === 2) {
    roundedDate.setHours(floorBy(date.getHours(), amount), 0, 0, 0)
  }

  if (unitIndex === 3) {
    roundedDate.setDate(floorBy(date.getDate(), amount))
    roundedDate.setHours(0, 0, 0, 0)
  }

  if (unitIndex === 4) {
    roundedDate.setMonth(floorBy(date.getMonth(), amount), 1)
    roundedDate.setHours(0, 0, 0, 0)
  }

  return roundedDate
}

export function ceilDate(date: Date, { unit, amount = 1 }: Timespan) {
  const roundedDate = floorDate(date, { unit, amount })

  if (roundedDate.getTime() === date.getTime()) return roundedDate

  const unitMsVal = unitMs[unit]

  return new Date(roundedDate.getTime() + unitMsVal * amount)
}
